import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import { capitalize } from '@btime/helpers'
import React from 'react'

import { SmallText, Title } from '../../../../components/presentation/Text'
import { useChecklistTypes } from '../../_load/ChecklistTypesLoader'
import CardSelector from '../../../../components/form/CardSelector'
import ControlBar from './ControlBar'
import Icon from '../../../../components/shapes/Icon'
import TagPicker from '../../../../components/form/TagPicker'

const ChecklistTypesCardSelector = ({ option, ...props }) => {
  const checklistTypes = option.origin

  const body = (
    <div>
      <Title size="h6" bold noMargin>
        {option.label}
      </Title>
      <SmallText color={COLORS.dark3}>{checklistTypes.resume}</SmallText>
    </div>
  )

  const head = <Icon name={checklistTypes.type === 'person' ? 'BsPersonSquare' : 'BsBuilding'} color={COLORS.dark4} />

  return <CardSelector head={head} body={body} width="25%" widthOnSm="50%" {...props} />
}

const ChecklistTypesPicker = ({ selectedLabel, ...props }) => {
  const checklistTypes = useChecklistTypes()
  const options = checklistTypes.map(item => ({
    label: capitalize(item.name),
    value: props.idField ? item : item.id,
    origin: item
  }))

  if (props.value == 'all') return false

  return <TagPicker options={options} Selector={ChecklistTypesCardSelector} {...props} />
}

const Wrapper = ({ selectedLabel, useSelectAll, ...props }) => (
  <FilterHandler>
    <ControlBar
      selectedLabel={selectedLabel}
      useSelectAll={useSelectAll}
      value={props.value}
      onChange={props.onChange}
      disabledLoader={props.value == 'all'}
    >
      <ChecklistTypesPicker {...props} />
    </ControlBar>
  </FilterHandler>
)

export default Wrapper
